const TOPICS = [
  { label: '明星恋情', count: '128.6万', hot: true },
  { label: '综艺撕逼', count: '96.3万', hot: true },
  { label: '税务风波', count: '85.1万', hot: true },
  { label: '直播翻车', count: '72.8万', hot: false },
  { label: '婚变传闻', count: '68.4万', hot: true },
  { label: '新剧路透', count: '59.2万', hot: false },
  { label: '红毯名场面', count: '51.7万', hot: false },
  { label: '选秀内幕', count: '43.5万', hot: true },
  { label: '明星穿搭', count: '38.2万', hot: false },
  { label: '私下偶遇', count: '29.8万', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热门话题</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            全网最热门的吃瓜话题标签，点击查看相关明星大瓜视频合集
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((item, i) => (
            <a
              key={i}
              href="#topics"
              className="group inline-flex items-center gap-2 px-4 py-2.5 bg-background-50 border border-background-200/70 rounded-full hover:border-primary-300/60 hover:bg-primary-50 transition-all duration-300 cursor-pointer no-underline"
            >
              {item.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500 flex-shrink-0"></span>
              )}
              <span className="text-sm text-foreground-800 font-medium whitespace-nowrap group-hover:text-primary-500 transition-colors">
                #{item.label}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}